import * as React from "react";

import SelectDatepicker from 'react-select-datepicker';

type Props = {
    value: any,
    OnDateChange: (date: Date) => void,
    minDate: Date,
    maxDate: Date
};

type State = {
    date: Date|null;
};

export class DateSelectComponent extends React.Component<Props, State> {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        let date = this.props.value !== null ? new Date(this.props.value) : null
        this.setState({
            date: date
        })
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.props.value !== prevProps.value) {
            let date = this.props.value !== null ? new Date(this.props.value) : null
            this.setState({
                date: date
            })
        }
    }

    // Declare state 
    state: State = {
        date: null
    }

    OnDateChange = (date) => {
        !!date && this.props.OnDateChange(date)
    }

    render() {
        return (
            <React.Fragment>
                <SelectDatepicker
                    value={this.state.date}
                    onDateChange={(date) => this.OnDateChange(date)}
                    minDate={new Date(this.props.minDate)}
                    maxDate={new Date(this.props.maxDate)}
                    showLabels={false}
                    format="day/month/year"
                />
            </React.Fragment>
        );
    }

}
